module.exports = __webpack_public_path__ + "media/assets/images/blog/app_three-small-433027b4cd7e1fccc184310c1926d403.jpg";